import { render, staticRenderFns } from "./StockviewListingAccordionCard.vue?vue&type=template&id=bf071b58&scoped=true&"
import script from "./StockviewListingAccordionCard.vue?vue&type=script&lang=js&"
export * from "./StockviewListingAccordionCard.vue?vue&type=script&lang=js&"
import style0 from "./StockviewListingAccordionCard.vue?vue&type=style&index=0&id=bf071b58&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf071b58",
  null
  
)

export default component.exports